<!--
 * @Descripttion:
 * @version:
 * @Author: Jeson
 * @Date: 2021-10-11 16:06:27
 * @LastEditors: Jeson
 * @LastEditTime: 2021-10-13 22:02:10
-->
<template>
    <div :class="['good-tag-box', themeType, { 'is-meet': isMeet }]">
        <div class="content">
            <div class="content_content">
                <BuyCarItemTag text="满赠"
                               bgColor="linear-gradient(328deg, #FF6831 0%, #F3180E 100%)" />
                <span class="van-ellipsis content-tips">{{ str }}</span></div>

            <span style="margin-right:2rem;color:#F3180E;cursor:pointer"
                  @click.stop="toBuy()">{{ "去加购  >" }}</span>
        </div>
    </div>
</template>
<script>
import BuyCarItemTag from './BuyCarItemTag.vue';
import { BaseMixin } from '@/mixins/BaseMixin'
export default {
    name: 'BuyCarGoodsActiveTagMore',
    mixins: [BaseMixin],
    components: { BuyCarItemTag },
    props: {
        themeType: {
            type: String,
            default: 'full-minus' // 默认满减
        },
        GiftList: {
            type: Array,
            default: () => []
        },
        ActivityId: {
            type: String,
            default: ''
        },
        activityGiftList: {
            type: Array,
            default: () => []
        },
        Multiple: {
            type: Number,
            default: 1
        }
    },
    watch: {
        GiftList: {
            handler (val) {
                if (val.length > 0) {
                    this.changeStr()
                }
            },
            immediate: true,
            deep: true
        },
        Multiple: {
            handler (val) {
                if (val.length > 1) {
                    this.changeStr()
                }
            },
            immediate: true,
            deep: true
        }
    },
    data () {
        return {
            str: 1,
            isMeet: true,
        };
    },
    // 生命周期
    created () { },
    mounted () { },
    unmounted () { },
    // 方法
    methods: {
        changeStr () {
            let active = this.activityGiftList.filter(oo => oo.Id == this.ActivityId)
            let giftTypeMsg = ''
            let type = active.ConditionType == 1 ? '满' : active.ConditionType == 2 ? '每满' : ''
            if (this.GiftList) {
                this.GiftList.map(yy => {
                    if (active.ConditionType == 1) {
                        giftTypeMsg += yy.Name + yy.Amount + yy.Unit + "、"
                    } else {
                        giftTypeMsg += yy.Name + yy.Amount * (this.Multiple == 0 ? 1 : this.Multiple) + "、"
                    }

                })
            }
            this.str = '已赠送' + giftTypeMsg
        },
        toBuy () {
            this._jump(
                this.Enum_LinkTypeCode.ActivityProductList,
                {
                    id: this.ActivityId,
                    str: '多商品满赠活动'
                },
                '_blank'
            )
        }
    }
};
</script>
<style lang="less" scoped>
.good-tag-box {
    height: 3.33rem;
    // margin-bottom: 1.33rem;
    line-height: 3.33rem;
    padding-left: 6px;
    box-sizing: border-box;
    display: block;
    font-size: 0;
    padding-right: 20px;
    // border-radius: 4px;
    max-width: max-content;
    // margin-bottom: 8px;
    &:last-child {
        // margin-bottom: 0;
    }
    .content {
        width: 1200px;
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 12px;
        justify-content: space-between;
        .content_content {
          width: 80%;
          overflow: hidden;
          padding-left:20px ;
            display: flex;
            // justify-content: center;
            align-items: center;
        }
    }
    &.full-minus {
        color: #ffffff;
        background: linear-gradient(328deg, #ff6831 0%, #f3180e 100%);
        background-size: 100%;
        &.is-meet {
            background: #ffeeec;
            background-size: 100%;
            color: #111a34;
        }
    }
}
</style>
